"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatCards = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
exports.ChatCards = styled_1.default.div({
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    height: 0,
    overflowY: 'auto',
});
